import React from 'react';
import { 
  ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, 
  Tooltip, Legend, ResponsiveContainer, Area 
} from 'recharts';

const data = [
  { year: '1948', realWage: 15.00, productivity: 15.00 },
  { year: '1960', realWage: 19.50, productivity: 20.00 },
  { year: '1973', realWage: 25.00, productivity: 26.00 }, // The "Decoupling" Point
  { year: '1990', realWage: 26.50, productivity: 40.00 },
  { year: '2010', realWage: 28.00, productivity: 62.00 },
  { year: '2024', realWage: 31.00, productivity: 75.00 },
];

const WageChart = () => (
  <div style={{ width: '100%', height: '450px', background: '#111827', padding: '25px', borderRadius: '12px', border: '1px solid #374151' }}>
    <h3 style={{ color: '#fca5a5', textAlign: 'center', marginBottom: '10px' }}>The Great Decoupling: Wages vs. Productivity</h3>
    <p style={{ color: '#9ca3af', fontSize: '12px', textAlign: 'center', marginBottom: '20px' }}>Adjusted for Inflation (2024 Dollars)</p>
    
    <ResponsiveContainer width="100%" height="85%">
      <ComposedChart data={data} margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
        <CartesianGrid stroke="#374151" strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="year" stroke="#9ca3af" fontSize={12} tickLine={false} />
        <YAxis stroke="#9ca3af" fontSize={12} tickFormatter={(value) => `$${value}`} />
        <Tooltip 
          contentStyle={{ backgroundColor: '#1f2937', border: '1px solid #374151', borderRadius: '8px' }}
        />
        <Legend verticalAlign="top" height={36}/>
        
        {/* Shaded Area showing the Gap */}
        <Area type="monotone" dataKey="productivity" fill="#dc2626" stroke="none" fillOpacity={0.1} />
        
        {/* Productivity Line (The "What If") */}
        <Line 
          name="Economic Productivity" 
          type="monotone" 
          dataKey="productivity" 
          stroke="#dc2626" 
          strokeWidth={3} 
          dot={{ r: 4 }}
        />
        
        {/* Real Wage Bar (The "Reality") */}
        <Bar 
          name="Real Hourly Wage" 
          dataKey="realWage" 
          barSize={40} 
          fill="#fca5a5" 
          radius={[4, 4, 0, 0]} 
        />
      </ComposedChart>
    </ResponsiveContainer>
    <p style={{ color: '#f87171', fontSize: '11px', marginTop: '15px', fontStyle: 'italic' }}>
      *Since 1973, productivity has grown 3x faster than typical worker pay.
    </p>
  </div>
);

export default WageChart;